export const patientDetails = {
  backToAllPatients: "Back to all {{patientTermPlural}}",
  currentSupplements: {
    title: "Current supplements",
    currentlyTaking: "Currently taking",
    intakeNotInitiated: {
      beta: "BETA",
      title: "{{firstName}} has not added any products",
      description:
        "Build a better plan in less time by getting the complete list of the products {{firstName}} is already taking.",
    },
    noSupplements: {
      details: "Currently taking details",
      title: "{{firstName}} reported that they're not taking any products",
      description: "You'll find any products {{firstName}} adds here in the future.",
    },
    intakeRequestSent: {
      title: "Currently taking request sent",
      description: "You will be notified if {{firstName}} adds any products.",
      successMessage: "Currently taking request sent",
      requestedOn: "Requested on {{date}}",
    },
    supplementPlanCard: {
      hideIngredients: "Hide ingredients",
      showIngredients: "Show ingredients",
      productIngredientsUnavailable: "Daily consumption data isn't available for this product.",
      notOnFullscript: "Not on Fullscript",
      ingredients: "Ingredients",
      medications: "Medications",
      supplements: "Supplements",
    },
    supplementExportDropdownOptions: {
      label: "Current supplement export options",
      notes: "Copy details",
    },
    requestSupplementDetailsButton: {
      label: "Request supplements and medications",
      tooltip:
        "You have already requested currently taking products from {{firstName}}. You will be notified by email when they have updated the supplements and medications they are currently taking.",
    },
  },
  plans: {
    editTooltip: "You can't edit plans that another practitioner has created.",
    kebab: {
      cancelTooltip: "You can't cancel plans that another practitioner has created.",
      cancelWellevateTooltip: "You can't cancel plans created on Wellevate platform",
      deleteTooltip: "You can't delete plans that another practitioner has created.",
      deleteWellevateTooltip: "You can't delete plans created on Wellevate platform",
      cancelPlanWithLabTooltipOld: "You can't cancel plans with labs",
      cancelPlanWithLabTooltip: "Cannot remove lab tests that have already been purchased",
    },
  },
  labs: {
    activateLabKitCTA: "Activate a lab kit stocked in office",
    activateLabKitButton: "Activate lab kit",
  },
  sharedBox: {
    signUpEmptyState: {
      altText: "Explore {{type}}",
    },
  },
  labsBox: {
    signUpEmptyState: {
      title: "Elevate {{patientTerm}} care with labs",
      body: "Use lab testing to get a more accurate snapshot of your {{-patientTermPossessive}} health.",
      CTA: "Explore labs",
    },
    noDataEmptyState: {
      title: "No labs sent",
      body: "Build plan to recommend labs and gain valuable insights into {{patientFirstName}}'s health.",
    },
  },
  currentlyTakingBox: {
    triggerContent: "Supplements and medications",
    signUpEmptyState: {
      title: "No supplements or medications",
      body: "Ask your {{patientTerm}} to add what they're currently taking to see interactions and depletions.",
      CTA: "Request",
    },
    noDataEmptyState: {
      title: "Request sent on {{date}}",
      body: "You'll be notified if {{firstName}} adds any products.",
      CTA: "Send reminder",
    },
    currentlyTakingList: {
      header: {
        title: "Supplements and medications",
        subtitle: "Updated: {{date}}",
      },
      secondaryTriggerContent: "Show ingredients",
      expandedSecondaryTriggerContent: "Hide ingredients",
    },
  },
  HowItWorks: "How it works",
  KeyDetails: "Key details",
  KeyDetailsDescription: "This information can help highlight risks in {{treatmentPlanTerm}}",
  AddKeyDetails: "Add key details",
  PregnancyOrNursing: "Pregnancy or nursing",
  PregnantOrNursing: "Pregnant or nursing",
  Pregnant: "Pregnant",
  Nursing: "Nursing",
  TryingToConceive: "Trying to conceive",
  CurrentSmokerDaily: "Current smoker (daily)",
  CurrentSmokeSometimes: "Current smoker (sometimes)",
  FormerSmoker: "Former smoker",
  NeverSmoked: "Never smoked",
  Unknown: "Unknown",
  NotAvailable: "N/A",
  Conditions: "Conditions",
  Allergies: "Allergies",
  ProductPreferences: "Product preferences",
  TobaccoUse: "Tobacco use",
  NoneSelected: "None selected",
  OnlyYouCanViewAndEdit: "Only you can view and edit this information",
  ViewAllCount: "View all ({{count}})",
} as const;
